import queryString from 'querystring';

const hasQueryString = url => url.indexOf('?') !== -1;

const removeQueryString = url => url.substr(0, url.indexOf('?'));

const queryStringFromUrl = url => url.substr(url.indexOf('?')).substr(1);

const addQueryToUrl = (url, qs) => {
  const baseUrl = hasQueryString(url) ? removeQueryString(url) : url;

  return qs ? `${baseUrl}?${qs}` : baseUrl;
};

const getQueryString = (url, query) =>
  queryString.encode(
    Object.assign(queryString.decode(queryStringFromUrl(url)), query)
  );

export const withQueryString = (url, query) =>
  addQueryToUrl(url, getQueryString(url, query));

function productSectionToClassicIdParam(section = 'main') {
  switch (section) {
    case 'properties':
      return 'e';
    case 'reviews':
      return 'o';
    case 'statistics':
      return 'pu';
    default:
      return 'p';
  }
}

const linkTo = (
  useClassicUrls,
  useHashForProductTabs,
  classicRoutes,
  routes,
  type,
  item = {},
  query = {}
) => {
  // Support both graphql schema and api schema
  const semanticId = item.pathName || item.semantic_id;
  const externalUri = item.externalUri || item.redirect_uri;

  function linkToProduct(section) {
    const classicIdParam = useHashForProductTabs
      ? 'p'
      : productSectionToClassicIdParam(section);

    const path = useClassicUrls
      ? withQueryString(
          classicRoutes.product,
          Object.assign({}, query, { [classicIdParam]: item.id })
        )
      : `${withQueryString(semanticId, query)}${
          !useHashForProductTabs && section ? `/${section}` : ''
        }`;

    return useHashForProductTabs && section ? `${path}#${section}` : path;
  }

  switch (type) {
    case 'raw': {
      return externalUri;
    }
    case 'product':
    case 'raw_sorted': {
      return linkToProduct();
    }
    case 'productProperties': {
      return linkToProduct('properties');
    }
    case 'productReviews': {
      return linkToProduct('reviews');
    }
    case 'productPriceHistory': {
      return linkToProduct('statistics');
    }
    case 'productAlert': {
      return useClassicUrls
        ? withQueryString(
            classicRoutes.product + routes.productAlert.relativePath,
            Object.assign({}, query, { p: item.id })
          )
        : withQueryString(semanticId + routes.productAlert.relativePath, query);
    }
    case 'productCompare': {
      const { category, products } = item;
      const categoryId = category && category.id;

      const productIds = Array.isArray(products)
        ? products.map(p => p.id).join(',')
        : '';

      return withQueryString(
        routes.productCompare.path.replace(':productIds', productIds),
        categoryId ? { categoryId } : {}
      );
    }
    case 'brand': {
      return useClassicUrls
        ? withQueryString(
            classicRoutes.brand,
            Object.assign({}, query, { t: item.id })
          )
        : withQueryString(semanticId, query);
    }

    case 'store': {
      return useClassicUrls
        ? withQueryString(
            classicRoutes.store_info,
            Object.assign({}, query, { f: item.id })
          )
        : withQueryString(semanticId, query);
    }

    case 'brandCategory':
    case 'brand_category':
    case 'brand_virtual_category':
      if (item.productCollection) {
        // eslint-disable-next-line no-param-reassign
        query.brand = item.brandId;
      } else if (useClassicUrls) {
        // eslint-disable-next-line no-param-reassign
        query.t = item.brandId;
      } else {
        // eslint-disable-next-line no-param-reassign
        query.brand = item.brandId;
      }
    case 'virtual_category': // eslint-disable-line no-fallthrough
    case 'virtualCategory':
    case 'category': {
      if (item.product_collection || item.productCollection) {
        return withQueryString(
          item.product_collection || item.productCollection,
          query
        );
      }

      return useClassicUrls
        ? withQueryString(
            classicRoutes.category,
            Object.assign({}, query, { k: item.id })
          )
        : withQueryString(semanticId, query);
    }
    case 'shopOfTheYear': {
      return routes.shopOfTheYear.path;
    }
    case 'shopOfTheYearCategory': {
      return routes.shopOfTheYearCategory.path
        .replace(':year', item.year)
        .replace(':id', item.id);
    }
    case 'shopOfTheYearWinners': {
      return routes.shopOfTheYearWinners.path.replace(':year', item.year);
    }
    case 'giftGuide': {
      return `${routes.themes.path}/${item.slug}`;
    }
    case 'productCollectionSitemap': {
      const { baseUrl } = item;
      return baseUrl.replace('/c/', '/cm/');
    }
    default:
      return null;
  }
};
export default linkTo;
